import { FormattedMessage } from "react-intl";
import getMessage from "../utils/getMessage";

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MONTH = 30 * DAY; // approx
const YEAR = 12 * MONTH; // approx;

/**
 * Made because the intl FormattedRelativeTime shows "1 year ago" if
 * it's the 1st of January and the timestamp is on the day 
 * before, 31st of December, and "1 month ago" if the month changed
 * 5 seconds ago, etc.
 */
const DigiraatiRelativeTime = ({date}) => {

  if (!date) {
    return <span>...</span>
  }

  const nowUnix = Date.now();
  const dateUnix = date.getTime();
  const diffSeconds = parseInt( (nowUnix - dateUnix) / 1000 );

  const justNowCutout = 2 * MINUTE;
  if (diffSeconds < justNowCutout) {
    return <FormattedMessage id="relativeTimeJustNow"/>
  }

  const calculateSinceAndUnit = (diffSeconds) => {
    let since;
    let unit;
    if (diffSeconds > YEAR) {
      since = diffSeconds / YEAR;
      unit = 'Year';
    } else if (diffSeconds > MONTH) {
      since = diffSeconds / MONTH;
      unit = 'Month';
    } else if (diffSeconds > DAY) {
      since = diffSeconds / DAY;
      unit = 'Day';
    } else if (diffSeconds > HOUR) {
      since = diffSeconds / HOUR;
      unit = 'Hour'
    } else {
      since = diffSeconds / MINUTE;
      unit = 'Minute'
    } 
    since = parseInt(since);
    if (since !== 1) {
      unit += 's'; // plural
    }
    const translatedUnit = getMessage(`relativeTimeUnit${unit}`)
    return {
      since,
      unit: translatedUnit,
    }
  }

  const {since, unit} = calculateSinceAndUnit(diffSeconds);

  return (
    <FormattedMessage 
      id="relativeTimeAgo"
      values={{since, unit}}
    />
  )

}

export default DigiraatiRelativeTime;